// extracted by mini-css-extract-plugin
module.exports = {"poll":"style_poll__F_3Yb","option":"style_option__80y4w","item":"style_item__IRTLi","pollItem":"style_pollItem__tXzfb"};